import { StyleSheet, Text, View, ActivityIndicator } from 'react-native'
import React from 'react'
import { ActionButton, LabledTextField } from '../SharedWidgets/LoginAndSignup';
import { useResetPasswordStore } from './Store';



export default function PasswordResetScreen() {


    const {
        newPassword,
        newcPassword,
        setNewPassword,
        setNewCPassword,
        toggleNewPasswordEye,
        toggleNewCPasswordEye,
        updatePassword,
        updating,
        newCPasswordEyeOpen,
        newPasswordeyeOpen,
    } = useResetPasswordStore();

    async function updateProcess() {
        const trimmedPassword = newPassword.trim();
        const trimmedConfirm = newcPassword.trim();

        // Required check
        if (!trimmedPassword || !trimmedConfirm) {
            window.alert("Both password fields are required.");
            return;
        }

        // Minimum length check
        if (trimmedPassword.length < 6) {
            window.alert("Password must be at least 6 characters long.");
            return;
        }

        // Match check
        if (trimmedPassword !== trimmedConfirm) {
            window.alert("Passwords do not match.");
            return;
        }

        updatePassword(() => {
            window.alert("Password Updated");
            window.location.assign('/');
        })

    }


    return (
        <View style={styles.root}>

            <Text
                style={{ fontFamily: 'Poppins_700Bold', fontSize: 24, textAlign: "center" }}
            >
                Create New Password
            </Text>

            <LabledTextField
                title="Password"
                hint='Enter New Password'
                useEye={true}
                value={newPassword}
                eyeState={newPasswordeyeOpen}
                onValueChange={setNewPassword}
                toggleEye={toggleNewPasswordEye}
            />
            <LabledTextField
                title="Confirm Password"
                hint='Re-Enter New Password'
                useEye={true}
                value={newcPassword}
                eyeState={newCPasswordEyeOpen}
                onValueChange={setNewCPassword}
                toggleEye={toggleNewCPasswordEye}
            />
            <ActionButton
                label='Submit' onClick={updateProcess}
            />
            {updating &&
                <ActivityIndicator
                    size="large"
                    color="#007AFF"
                />}

        </View>
    )
}

const styles = StyleSheet.create({
    root: {
        backgroundColor: "white",
        flex: 1,
        gap: 12,
        paddingHorizontal: 12,
        paddingVertical: 12,
    }
});